import styled from "styled-components";

export const Container = styled.main`
    max-width: 100%;
    margin: 0 auto;

    padding: 2.5rem 1rem;

    @media (max-width: 768px) {
        padding: 1.5rem 0.5rem;
    }

    @media (max-width: 480px) {
        padding: 1rem 0.25rem;
    }

`;